<template>
  <div class="mt-0">
    <v-dialog />
    <div class="row" style="border-bottom: 2px solid var(--color-lightGrey)">
      <div class="col">
        <h3 style="display: inline; padding-right: 1rem">
          Ultrix Routing System details
        </h3>
        <ZmdiRefresh v-show="isLoading == true" class="spin" />
      </div>

      <button
        class="button primary col-3"
        style="pointer-events: auto"
        :title="legacyItemsMsg"
        :disabled="legacyItems.status"
        @click="sendRequest()"
      >
        Submit Request
      </button>
    </div>
    <div class="row">
      <div class="col">
        <label class="text-sm" for="reqName">Name</label>
        <ClickToEdit :value="reqName" @input-save="saveReqName" />
      </div>
      <div class="col-2">
        <label class="text-sm" for="reqName">Time/Date</label>
        <span class="text-block">{{ request.date || "no data" }}</span>
      </div>
      <div class="col-1 hide-xs hide-sm">
        <label class="text-sm" for="reqName">Status</label>
        <span class="text-block">{{ request.status || "no status" }}</span>
      </div>
      <div class="col-3 is-center is-vertical-align">
        <button
          class="button icon outline white btn-sm hovred"
          @click="deleteDialog('system', request_id)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M7 21q-.825 0-1.413-.588T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.588 1.413T17 21H7ZM17 6H7v13h10V6ZM9 17h2V8H9v9Zm4 0h2V8h-2v9ZM7 6v13V6Z"
            />
          </svg>
          Delete System
        </button>
        <button
          class="button outline icon white btn-sm hover-blueGrey"
          @click="duplicateSystem(request_id)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
          >
            <path fill="currentColor" d="M3 22V6h2v14h11v2H3Zm4-4V2h13v16H7Z" />
          </svg>
          Duplicate System
        </button>
      </div>
    </div>
    <table v-if="request" class="table requestview">
      <tr
        v-for="(value, key, index) in request.chassis"
        v-bind:key="index"
        style="line-height: 35px"
      >
        <td>{{ key }}:&nbsp;&nbsp; {{ value.name }}</td>
        <td style="text-align: right">
          <button
            class="button outline white btn-sm hovred"
            @click="deleteDialog('frame', key)"
          >
            Delete</button
          >&nbsp;
          <button
            class="button outline white btn-sm hover-blueGrey"
            @click="duplicateChassis(key, value.name)"
          >
            Duplicate
          </button>
          <button
            class="button outline white btn-sm hover-primary"
            @click="legacyCheck(key, value.name)"
          >
            Open</button
          >&nbsp;
        </td>
      </tr>
      <tr>
        <td>
          <button class="button primary btn-sm" @click="addChassis()">
            &plus; Add another frame
          </button>
        </td>
        <td></td>
      </tr>
    </table>

    <p v-else>
      <strong>This request does not yet have any Ultrix Platforms yet.</strong>
    </p>
    <div class="mt-1">
      <button class="button icon btn-sm" @click="$router.push('/')">
        <div class="px-0">
          <ZmdiChevronLeft />
        </div>
        Return Home
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ZmdiChevronLeft from "../components/base/ZmdiChevronLeft.vue";
import ZmdiRefresh from "../components/base/ZmdiRefresh.vue";
import ClickToEdit from "../components/base/ClickToEdit.vue";

export default {
  name: "RequestView",
  data() {
    return {
      isEditing: false,
      new_reqName: "",
    };
  },
  props: {
    request_id: { type: Number, default: 1 },
  },
  computed: {
    ...mapGetters({
      isLoading: "profile/getIsLoading",
    }),
    legacyItems() {
      return this.$store.getters.getProfileRequestLegacyStatus(this.request_id);
    },
    legacyItemsMsg() {
      let res = "";
      if (this.legacyItems.status == true) {
        res =
          "This system contains legacy frames. You may not submit legacy hardware for quote.";
      }
      return res;
    },
    reqName: {
      get() {
        return this.request.name;
      },
    },
    request() {
      if (
        Object.keys(this.$store.state.profile.profileData.payload).length ===
          0 &&
        this.$store.state.profile.profileData.payload.constructor === Object
      ) {
        // console.log("no chassis in request");
        return {};
      } else {
        return this.$store.state.profile.profileData.payload.requests[
          this.request_id
        ];
      }
    },

    /* isLoading() {
      return this.$store.state.profile.isLoading;
    }, */
    next_chassis_id() {
      return (
        Object.keys(
          this.$store.state.profile.profileData.payload.requests[
            this.request_id
          ].chassis
        ).length + 1
      );
    },
  },
  methods: {
    editName() {
      this.isEditing = true;
    },
    deleteDialog(type, id) {
      //type = frame of system
      this.$modal.show("dialog", {
        text: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="red" d="M1 21L12 2l11 19H1Zm11-3q.425 0 .713-.288T13 17q0-.425-.288-.713T12 16q-.425 0-.713.288T11 17q0 .425.288.713T12 18Zm-1-3h2v-5h-2v5Z"/></svg>&nbsp;Are you sure you want to delete this ${type}?`,
        buttons: [
          {
            title: "No",
            handler: () => {
              this.$modal.hide("dialog");
            },
          },
          {
            title: "Yes",
            handler: () => {
              if (type == "frame") {
                this.deleteChassis(id);
              }
              if (type == "system") {
                this.deleteSystem(id);
              }

              // this.$modal.hide("dialog");
            },
          },
        ],
      });
    },
    upgradeLegacyDialog(id, name) {
      //type = frame of system
      this.$modal.show("dialog", {
        text: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="red" d="M1 21L12 2l11 19H1Zm11-3q.425 0 .713-.288T13 17q0-.425-.288-.713T12 16q-.425 0-.713.288T11 17q0 .425.288.713T12 18Zm-1-3h2v-5h-2v5Z"/></svg><br />The ULTRIX-FR5 frame has now been superceded with ULTRIX-NS-FR5. <br />Do you want to upgrade this configuration to the new frame style? <br /><span style='font-size:smaller;'> Note you cannot submit configurations for quote untill all legacy frames have been upgraded and saved.</span>`,
        buttons: [
          {
            title: "No",
            handler: () => {
              this.loadChassis(id, name);
              this.$modal.hide("dialog");
            },
          },
          {
            title: "Yes",
            handler: () => {
              this.$store.commit("profile/upgradeFR5chassis", {
                request_id: this.request_id,
                chassis_id: Number(id),
              });
              this.loadChassis(id, name);
              this.$modal.hide("dialog");
            },
          },
        ],
      });
    },

    deleteSystem(id) {
      this.$store.commit("profile/deleteRequest", id);
      this.$store.dispatch("profile/saveData").then(() => {
        setTimeout(() => {
          this.$modal.hide("dialog");
          this.$router.push({ path: "/" });
        }, 1000);
      });
    },
    saveReqName(newName) {
      // console.log(newName);
      // this.$refs.reqName.blur();
      this.$store.dispatch("profile/saveRequestName", {
        reqId: this.request_id,
        reqName: newName,
      });
      this.isEditing = false;
    },

    evt(e) {
      // console.log(e.target.value);
      this.isEditing = true;
      this.reqName = e.target.value;
    },
    sendRequest() {
      this.$router.push("Submit");
    },
    addChassis() {
      this.$root.chassis_id = this.next_chassis_id;
      //this.$root.request_id=
      this.$store.dispatch("resetStartState");
      //copy request.services as these are global
      this.$store.dispatch("copyServices", this.$root.request_id);
      this.$router.push("StepOne");
    },
    legacyCheck(id, name) {
      if (
        this.$store.state.profile.profileData.payload.requests?.[
          this.request_id
        ].chassis?.[id].frame.model === "ULTRIX-FR5"
      ) {
        //show upgrade dialog
        this.upgradeLegacyDialog(id, name);
      } else {
        this.loadChassis(id, name);
      }
    },
    loadChassis(id, name) {
      // console.log("load chassis ", id);

      this.$store.commit("loadprofileDataChassis", {
        request_id: this.request_id,
        chassis_id: Number(id),
      });

      this.$root.request_id = this.request_id;
      this.$root.chassis_id = id;
      this.$root.chassis_name = name;
      this.$root.request_name = this.request.name;
      this.$router.push("/StepTwo");
    },
    duplicateChassis(id) {
      this.$store.dispatch("profile/duplicateChassis", {
        reqId: this.request_id,
        chassisId: Number(id),
      });
    },
    deleteChassis(id) {
      // console.log("delete chassis ", id);
      if (Object.keys(this.request.chassis).length > 1) {
        this.$store.commit("profile/deleteProfileDataChassis", {
          request_id: this.$root.request_id,
          chassis_id: id,
        });
        this.$store.dispatch("profile/saveData", { token: this.$root.token });
      } else {
        //delete entire request if no chassis in it
        this.$store.commit("profile/deleteRequest", this.$root.request_id);
        this.$store.dispatch("profile/saveData", { token: this.$root.token });
        if (!this.isLoading) {
          this.$router.push({ path: "/" });
        }
      }
      this.$modal.hide("dialog");
    },
    duplicateSystem() {
      this.$modal.show("dialog", {
        text: "This will copy the exiting system (all frames) to a new system '_copy'",
        buttons: [
          {
            title: "Exit",
            handler: () => {
              this.$modal.hide("dialog");
            },
          },
          {
            title: "Okay",
            handler: () => {
              this.$store
                .dispatch("profile/duplicateSystem", {
                  reqId: this.request_id,
                })
                .then(() => {
                  this.$store.dispatch("profile/saveData").then(() => {
                    setTimeout(() => {
                      this.$modal.hide("dialog");
                      this.$router.push({ path: "/" });
                    }, 1000);
                  });
                });
            },
          },
        ],
      });
    },
  },
  components: { ZmdiChevronLeft, ZmdiRefresh, ClickToEdit },
};
</script>

<style scoped>
.table.requestview {
  border-top: 1px solid var(--color-lightGrey);
  border-bottom: 2px solid var(--color-lightGrey);
  border-left: none;
  border-right: none;
}
.table.requestview > tr {
  border-bottom: 1px solid var(--bg-secondary-color);
}
.text-block {
  display: block;
  margin-top: 6px;
}
.longname {
  max-width: 40em;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.hovred:hover {
  color: white;
  background-color: var(--color-ross-red) !important;
}
.hover-blueGrey:hover {
  color: white;
  background-color: var(--color-blueGrey) !important;
}
.hover-primary:hover {
  color: white;
  background-color: var(--color-primary) !important;
}
</style>
